import React from 'react';

import { Block, withConfig } from '../common/Block.jsx';
import { EmptyContentPlaceholder } from '../layout/Builder.jsx';
import Layout from '../common/Layout.jsx';
import Name from '../common/Name.jsx';
import PageType from '../common/PageType.jsx';
import Utilities from '../common/Utilities.jsx';

function _SocialComponentV2(props) {
    return <_SocialComponent {...props} v2={true} />
}
const SocialComponentV2 = withConfig(_SocialComponentV2);

function _SocialComponent(props) {
    let data;
    if (props.blockConfig && props.blockConfig.social) {
        data = props.blockConfig.social;
    }
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit({}, props);
    if (!data || data.length == 0) {
        if (props.builder) {
            const containerStyle = { width: '100%' };
            Utilities.copyObject(layoutStyles.containerStyle, containerStyle);
            return <EmptyContentPlaceholder containerStyle={containerStyle} style={layoutStyles.style}>This social block doesn't have any platforms yet, but you can add them under the Platforms section.</EmptyContentPlaceholder>
        }
        return null;
    }
    let alignment, columnCount, columnSpacing, lineSpacing;
    if (props.blockConfig) {
        if (props.blockConfig.block) {
            columnCount = parseInt(props.blockConfig.block.columns, 10);
            if (columnCount != 1) {
                columnSpacing = props.blockConfig.block.columnSpacing;
            }
            if (props.blockConfig.block.lineSpacing && props.blockConfig.block.lineSpacing.value && props.blockConfig.block.lineSpacing.value.length > 0 && props.blockConfig.block.lineSpacing.unit) {
                lineSpacing = `${props.blockConfig.block.lineSpacing.value}${props.blockConfig.block.lineSpacing.unit}`;
            }
        }
        if (props.blockConfig.layout) {
            alignment = props.blockConfig.layout.textAlign;
        }
    }
    if (columnCount == undefined) {
        // Default column count
        columnCount = 5;
    }
    if (props.builder || props.disabled) {
        layoutStyles.style.pointerEvents = 'none';
    }
    const rowProps = {};
    Utilities.copyObject(props, rowProps);
    Utilities.copyObject({
        alignment,
        columnCount,
        columnSpacing,
        lineSpacing,
        listData: data
    }, rowProps);
    let contentData = [];
    let rowData = [];
    data.forEach((d, i) => {
        if (columnCount > 0 && rowData.length == columnCount) {
            contentData.push(<SocialRow key={`row-${contentData.length}`} rowData={rowData} {...rowProps} />);
            rowData = [];
        }
        rowData.push({ data: d, index: i });
    })
    if (rowData.length > 0) {
        contentData.push(<SocialRow key={`row-${contentData.length}`} rowData={rowData} {...rowProps} />);
    }
    let className = 'cont--social';
    if (!props.inLayout) {
        className += ' cont--kit__content';
    }
    let content = (
        <div className={className} style={layoutStyles.style}>
            {contentData}
        </div>
    );
    if (layoutStyles.containerStyle) {
        let wrapperClassName;
        switch (props.pageType) {
            case PageType.Footer:
            case PageType.Header:
                break;
            default:
                wrapperClassName = 'cont--kit__wrapper';
        }
        content = <div className={className} style={layoutStyles.containerStyle}>{content}</div>
    }
    return content;
}
const SocialComponent = withConfig(_SocialComponent);

function SocialRow(props) {
    const style = { display: 'flex', flexWrap: 'wrap' };
    switch (props.alignment) {
        case 'left':
            style.justifyContent = 'flex-start';
            break;
        case 'right':
            style.justifyContent = 'flex-end';
            break;
        case 'center':
        default:
            style.justifyContent = 'center';
            break;
    }
    return (
        <div style={style}>
            {
                props.rowData &&
                props.rowData.map((d) =>
                    <SocialCell
                        {...props}
                        key={d.index}
                        data={d.data}
                        index={d.index} />
                )
            }
        </div>
    );
}

function SocialCell(props) {
    const style = {};
    let key;
    if (props.columnSpacing && props.columnSpacing.value && props.columnSpacing.unit) {
        switch (props.alignment) {
            case 'left':
                key = 'marginRight';
                if (props.columnCount == 0 && props.listData && props.index == props.listData.length - 1) {
                    // Last cell in single row social container gets no column spacing
                    break;
                }
            // Intentional fallthrough
            case 'right':
                if (!key) {
                    key = 'marginLeft'
                    if (props.columnCount == 0 && props.index == 0) {
                        // First cell in single row social container gets no column spacing
                        break;
                    }
                }
                style[key] = `${props.columnSpacing.value}${props.columnSpacing.unit}`;
                break;
            case 'center':
            default:
                let value = props.columnSpacing.value / 2;
                value = `${value}${props.columnSpacing.unit}`;
                style.marginLeft = value;
                style.marginRight = value;
                break;
        }
    }
    const styleSpacer = {};
    if (props.columnCount != 0) {
        styleSpacer.marginBottom = '25px';
        if (props.listData && props.lineSpacing) {
            if (Layout.shouldUseLineSpacing(props.index, props.listData.length, props.columnCount)) {
                style.marginBottom = props.lineSpacing;
            }
            styleSpacer.marginBottom = props.lineSpacing;
        }
    }
    let containerStyle, iconStyle, platform, target, url;
    if (props.data) {
        containerStyle = { alignItems: 'center', display: 'flex', justifyContent: 'center' };
        iconStyle = { lineHeight: 'unset' };
        Block.mapStyleConfigProps(containerStyle, props.data, (propName, propValue, propUnit) => {
            switch (propName) {
                case 'color':
                    iconStyle.color = propValue;
                    return true;
                case 'containerSize':
                    if (propValue && propUnit) {
                        containerStyle.height = `${propValue}${propUnit}`;
                        containerStyle.lineHeight = `${propValue}${propUnit}`;
                        containerStyle.width = `${propValue}${propUnit}`;
                    }
                    return true;
                case 'email':
                    url = `mailto:${propValue || ''}`;
                    return true;
                case 'fontSize':
                    if (propValue && propUnit) {
                        iconStyle.fontSize = `${propValue}${propUnit}`;
                    }
                    return true;
                case 'id':
                    return true;
                case 'newWindow':
                    if (propValue) {
                        target = '_blank';
                    }
                    return true;
                case 'platform':
                    platform = propValue;
                    return true;
                case 'url':
                    if (!url) {
                        url = propValue;
                    }
                    return true;
            }
        })
    }
    let iconClassName;
    switch (platform) {
        case 'spacer':
            containerStyle.height = '100%';
            containerStyle.lineHeight = 'unset';
            return <div style={style}><span style={containerStyle} /></div>
        default:
            const socialConfigProps = Name.SocialPlatform.configProps(platform, props.config, props.v2);
            iconClassName = socialConfigProps.iconClassName;
            url = url || socialConfigProps.url;
            break;
    }
    return (
        <div className="cell--social" style={style}>
            <a aria-label={platform} href={url || '#'} style={containerStyle} target={target}>
                <span className={iconClassName} style={iconStyle} />
            </a>
            <div className="cell--spacer" style={styleSpacer} />
        </div>
    );
}

export default {
    V2: { Component: SocialComponentV2 },

    // DEPRECATED
    V1: { Component: SocialComponent }
};